import React from "react";

function ColumnHeader({ column, title }) {
  return <div className="text-data-table" style={{fontWeight: 500}}>{title}</div>;
}

export default ColumnHeader;
